export enum GraphicsType {
  /**
   * 线条
   */
  LINE = 'line',
  /**
   * 直线
   */
  STRAIGHT_CONNECTOR = 'straightConnector1',
  /**
   * 无控制点折线
   */
  BENT_CONNECTOR_0 = 'bentConnector2',
  /**
   * 单控制点折线
   */
  BENT_CONNECTOR_1 = 'bentConnector3',
  /**
   * 双控制点折线
   */
  BENT_CONNECTOR_2 = 'bentConnector4',
  /**
   * 三控制点折线
   */
  BENT_CONNECTOR_3 = 'bentConnector5',
  /**
   * 无控制点曲线
   */
  CURVED_CONNECTOR_0 = 'curvedConnector2',
  /**
   * 单控制点曲线
   */
  CURVED_CONNECTOR_1 = 'curvedConnector3',
  /**
   * 双控制点曲线
   */
  CURVED_CONNECTOR_2 = 'curvedConnector4',
  /**
   * 三控制点曲线
   */
  CURVED_CONNECTOR_3 = 'curvedConnector5',
  /**
   * 自定义图形
   */
  CUSTOM = 'custom',

  /**
   * 矩形
   */
  RECT = 'rect',
  /**
   * 矩形 = 圆角
   */
  ROUND_RECT = 'roundRect',
  /**
   * 矩形 = 剪去单角
   */
  SNIP_SINGLE_RECT = 'snip1Rect',
  /**
   * 矩形 = 剪去顶角
   */
  SNIP_SAME_SIDE_RECT = 'snip2SameRect',
  /**
   * 矩形 = 剪去对角
   */
  SNIP_DIAG_RECT = 'snip2DiagRect',
  /**
   * 矩形：一个圆顶角，剪去另一个顶角
   */
  SNIP_ROUND_RECT = 'snipRoundRect',
  /**
   * 矩形：单圆角
   */
  ROUND_SINGLE_RECT = 'round1Rect',
  /**
   * 矩形：圆顶角
   */
  ROUND_SAME_SIDE_RECT = 'round2SameRect',
  /**
   * 矩形：对角圆角
   */
  ROUND_DIAG_RECT = 'round2DiagRect',

  /**
   * 椭圆
   */
  ELLIPSE = 'ellipse',
  /**
   * 等腰三角形
   */
  TRIANGLE = 'triangle',
  /**
   * 直角三角形
   */
  RIGHT_TRIANGLE = 'rtTriangle',
  /**
   * 平行四边形
   */
  PARALLELOGRAM = 'parallelogram',
  /**
   * 菱形
   */
  DIAMOND = 'diamond',
  /**
   * 梯形
   */
  TRAPEZOID = 'trapezoid',
  /**
   * 五边形
   */
  PENTAGON = 'pentagon',
  /**
   * 六边形
   */
  HEXAGON = 'hexagon',
  /**
   * 七边形
   */
  HEPTAGON = 'heptagon',
  /**
   * 八边形
   */
  OCTAGON = 'octagon',
  /**
   * 十边形
   */
  DECAGON = 'decagon',
  /**
   * 十二边形
   */
  DODECAGON = 'dodecagon',
  /**
   * 不完整圆
   */
  PIE = 'pie',
  /**
   * 弦形
   */
  CHORD = 'chord',
  /**
   * 泪滴形
   */
  TEARDROP = 'teardrop',
  /**
   * 图文框
   */
  FRAME = 'frame',
  /**
   * 半闭框
   */
  HALF_FRAME = 'halfFrame',
  /**
   * L形
   */
  CORNER = 'corner',
  /**
   * 斜纹
   */
  DIAG_STRIPE = 'diagStripe',
  /**
   * 十字形
   */
  PLUS = 'plus',
  /**
   * 缺角矩形
   */
  PLAQUE = 'plaque',
  /**
   * 立方体
   */
  CUBE = 'cube',
  /**
   * 圆柱形
   */
  CAN = 'can',
  /**
   * 矩形：棱台
   */
  BEVEL = 'bevel',
  /**
   * 圆：空心
   */
  DONUT = 'donut',
  /**
   * 禁止符
   */
  NOT_ALLOWED = 'noSmoking',
  /**
   * 空心弧
   */
  BLOCK_ARC = 'blockArc',
  /**
   * 矩形：折角
   */
  FOLDED_CORNER = 'foldedCorner',
  /**
   * 笑脸
   */
  SMILEY_FACE = 'smileyFace',
  /**
   * 心形
   */
  HEART = 'heart',
  /**
   * 闪电形
   */
  LIGHTNING_BOLT = 'lightningBolt',
  /**
   * 太阳形
   */
  SUN = 'sun',
  /**
   * 新月形
   */
  MOON = 'moon',
  /**
   * 云形
   */
  CLOUD = 'cloud',
  /**
   * 弧形
   */
  ARC = 'arc',
  /**
   * 矩左中框号
   */
  LEFT_BRACKET = 'leftBracket',
  /**
   * 右中括号
   */
  RIGHT_BRACKET = 'rightBracket',
  /**
   * 左大括号
   */
  LEFT_BRACE = 'leftBrace',
  /**
   * 右大括号
   */
  RIGHT_BRACE = 'rightBrace',
  /**
   * 双括号
   */
  BRACKET_PAIR = 'bracketPair',
  /**
   * 双大括号
   */
  BRACE_PAIR = 'bracePair',

  /**
   * 箭头：右
   */
  RIGHT_ARROW = 'rightArrow',
  /**
   * 箭头：左
   */
  LEFT_ARROW = 'leftArrow',
  /**
   * 箭头：上
   */
  UP_ARROW = 'upArrow',
  /**
   * 箭头：下
   */
  DOWN_ARROW = 'downArrow',
  /**
   * 箭头：虚尾
   */
  STRIPED_RIGHT_ARROW = 'stripedRightArrow',
  /**
   * 箭头：燕尾形
   */
  NOTCHED_RIGHT_ARROW = 'notchedRightArrow',
  /**
   * 箭头：直角上
   */
  BENT_UP_ARROW = 'bentUpArrow',
  /**
   * 箭头：左右
   */
  LEFT_RIGHT_ARROW = 'leftRightArrow',
  /**
   * 箭头：上下
   */
  UP_DOWN_ARROW = 'upDownArrow',
  /**
   * 箭头：直角双向
   */
  LEFT_UP_ARROW = 'leftUpArrow',
  /**
   * 箭头：丁字
   */
  LEFT_RIGHT_UP_ARROW = 'leftRightUpArrow',
  /**
   * 箭头：十字
   */
  QUAD_ARROW = 'quadArrow',
  /**
   * 箭头：圆角右
   */
  BENT_ARROW = 'bentArrow',
  /**
   * 箭头：手杖形
   */
  U_TURN_ARROW = 'uturnArrow',
  /**
   * 箭头：右弧形
   */
  CURVED_RIGHT_ARROW = 'curvedRightArrow',
  /**
   * 箭头：左弧形
   */
  CURVED_LEFT_ARROW = 'curvedLeftArrow',
  /**
   * 箭头：下弧形
   */
  CURVED_UP_ARROW = 'curvedUpArrow',
  /**
   * 箭头：上弧形
   */
  CURVED_DOWN_ARROW = 'curvedDownArrow',

  /**
   * 加号
   */
  MATH_PLUS = 'mathPlus',
  /**
   * 减号
   */
  MATH_MINUS = 'mathMinus',
  /**
   * 乘号
   */
  MATH_MULTIPLY = 'mathMultiply',
  /**
   * 除号
   */
  MATH_DIVIDE = 'mathDivide',
  /**
   * 等号
   */
  MATH_EQUAL = 'mathEqual',
  /**
   * 不等号
   */
  MATH_NOT_EQUAL = 'mathNotEqual',

  /**
   * 爆炸型1
   */
  IRREGULAR_SEAL_1 = 'irregularSeal1',
  /**
   * 爆炸型2
   */
  IRREGULAR_SEAL_2 = 'irregularSeal2',
  /**
   * 星形：四角
   */
  STAR_4 = 'star4',
  /**
   * 星形：五角
   */
  STAR_5 = 'star5',
  /**
   * 星形：六角
   */
  STAR_6 = 'star6',
  /**
   * 星形：七角
   */
  STAR_7 = 'star7',
  /**
   * 星形：八角
   */
  STAR_8 = 'star8',
  /**
   * 星形：十角
   */
  STAR_10 = 'star10',
  /**
   * 星形：十二角
   */
  STAR_12 = 'star12',
  /**
   * 星形：十六角
   */
  STAR_16 = 'star16',
  /**
   * 星形：二十四角
   */
  STAR_24 = 'star24',
  /**
   * 星形：三十二角
   */
  STAR_32 = 'star32',
  /**
   * 带形：前凸
   */
  RIBBON = 'ribbon',
  /**
   * 带形：上凸
   */
  RIBBON_2 = 'ribbon2',
  /**
   * 带形：前凸弯
   */
  ELLIPSE_RIBBON = 'ellipseRibbon',
  /**
   * 带形：上凸弯
   */
  ELLIPSE_RIBBON_2 = 'ellipseRibbon2',
  /**
   * 带形：左右弯
   */
  LEFT_RIGHT_RIBBON = 'leftRightRibbon',
  /**
   * 卷形：垂直
   */
  VERTICAL_SCROLL = 'verticalScroll',
  /**
   * 卷形：水平
   */
  HORIZONTAL_SCROLL = 'horizontalScroll',
  /**
   * 波形
   */
  WAVE = 'wave',
  /**
   * 双波形
   */
  DOUBLE_WAVE = 'doubleWave',

  /**
   * 标注：线形(无边框)
   */
  CALLOUT_1 = 'callout1',
  /**
   * 标注：弯曲线形(无边框)
   */
  CALLOUT_2 = 'callout2',
  /**
   * 标注：双弯曲线形(无边框)
   */
  CALLOUT_3 = 'callout3',
  /**
   * 标注：线形
   */
  ACCENT_CALLOUT_1 = 'accentCallout1',
  /**
   * 标注：弯曲线形
   */
  ACCENT_CALLOUT_2 = 'accentCallout2',
  /**
   * 标注：双弯曲线形
   */
  ACCENT_CALLOUT_3 = 'accentCallout3',
  /**
   * 标注：线形(带强调线)
   */
  BORDER_CALLOUT_1 = 'borderCallout1',
  /**
   * 标注：弯曲线形(带强调线)
   */
  BORDER_CALLOUT_2 = 'borderCallout2',
  /**
   * 标注：双弯曲线形(带强调线)
   */
  BORDER_CALLOUT_3 = 'borderCallout3',
  /**
   * 标注：线形(带边框和强调线)
   */
  ACCENT_BORDER_CALLOUT_1 = 'accentBorderCallout1',
  /**
   * 标注：弯曲线形(带边框和强调线)
   */
  ACCENT_BORDER_CALLOUT_2 = 'accentBorderCallout2',
  /**
   * 标注：双弯曲线形(带边框和强调线)
   */
  ACCENT_BORDER_CALLOUT_3 = 'accentBorderCallout3',
  /**
   * 对话气泡：矩形
   */
  WEDGE_RECT_CALLOUT = 'wedgeRectCallout',
  /**
   * 对话气泡：圆角矩形
   */
  WEDGE_ROUND_RECT_CALLOUT = 'wedgeRoundRectCallout',
  /**
   * 对话气泡：圆形
   */
  WEDGE_ELLIPSE_CALLOUT = 'wedgeEllipseCallout',
  /**
   * 思想气泡：云
   */
  CLOUD_CALLOUT = 'cloudCallout',

  /**
   * 流程图：过程
   */
  FLOW_CHART_PROCESS = 'flowChartProcess',
  /**
   * 流程图：决策
   */
  FLOW_CHART_DECISION = 'flowChartDecision',
  /**
   * 流程图：数据
   */
  FLOW_CHART_INPUT_OUTPUT = 'flowChartInputOutput',
  /**
   * 流程图：预定义过程
   */
  FLOW_CHART_PREDEFINED_PROCESS = 'flowChartPredefinedProcess',
  /**
   * 流程图：内部贮存
   */
  FLOW_CHART_INTERNAL_STORAGE = 'flowChartInternalStorage',
  /**
   * 流程图：文档
   */
  FLOW_CHART_DOCUMENT = 'flowChartDocument',
  /**
   * 流程图：多文档
   */
  FLOW_CHART_MULTI_DOCUMENT = 'flowChartMultidocument',
  /**
   * 流程图：终止
   */
  FLOW_CHART_TERMINATOR = 'flowChartTerminator',
  /**
   * 流程图：准备
   */
  FLOW_CHART_PREPARATION = 'flowChartPreparation',
  /**
   * 流程图：手动输入
   */
  FLOW_CHART_MANUAL_INPUT = 'flowChartManualInput',
  /**
   * 流程图：手动操作
   */
  FLOW_CHART_MANUAL_OPERATION = 'flowChartManualOperation',
  /**
   * 流程图：接点
   */
  FLOW_CHART_CONNECTOR = 'flowChartConnector',
  /**
   * 流程图：卡片
   */
  FLOW_CHART_PUNCHED_CARD = 'flowChartPunchedCard',
  /**
   * 流程图：资料带
   */
  FLOW_CHART_PUNCHED_TAPE = 'flowChartPunchedTape',
  /**
   * 流程图：汇总连接
   */
  FLOW_CHART_SUMMING_JUNCTION = 'flowChartSummingJunction',
  /**
   * 流程图：或者
   */
  FLOW_CHART_OR = 'flowChartOr',
  /**
   * 流程图：对照
   */
  FLOW_CHART_COLLATE = 'flowChartCollate',
  /**
   * 流程图：排序
   */
  FLOW_CHART_SORT = 'flowChartSort',
  /**
   * 流程图：摘录
   */
  FLOW_CHART_EXTRACT = 'flowChartExtract',
  /**
   * 流程图：合并
   */
  FLOW_CHART_MERGE = 'flowChartMerge',
  /**
   * 流程图：离线存储
   */
  FLOW_CHART_OFFLINE_STORAGE = 'flowChartOfflineStorage',
  /**
   * 流程图：存储数据
   */
  FLOW_CHART_ONLINE_STORAGE = 'flowChartOnlineStorage',
  /**
   * 流程图：顺序访问存储器
   */
  FLOW_CHART_MAGNETIC_TAPE = 'flowChartMagneticTape',
  /**
   * 流程图：磁盘
   */
  FLOW_CHART_MAGNETIC_DISK = 'flowChartMagneticDisk',
  /**
   * 流程图：直接访问存储器
   */
  FLOW_CHART_MAGNETIC_DRUM = 'flowChartMagneticDrum',
  /**
   * 流程图：显示
   */
  FLOW_CHART_DISPLAY = 'flowChartDisplay',
  /**
   * 流程图：延期
   */
  FLOW_CHART_DELAY = 'flowChartDelay',
  /**
   * 流程图：可选过程
   */
  FLOW_CHART_ALTERNATE_PROCESS = 'flowChartAlternateProcess',
  /**
   * 流程图：离页连接符
   */
  FLOW_CHART_OFF_PAGE_CONNECTOR = 'flowChartOffpageConnector',
  /**
   * 主页
   */
  ACTION_BUTTON_HOME = 'actionButtonHome',
  /**
   * 帮助
   */
  ACTION_BUTTON_HELP = 'actionButtonHelp',
  /**
   * 信息
   */
  ACTION_BUTTON_INFORMATION = 'actionButtonInformation',
  /**
   * 下一个
   */
  ACTION_BUTTON_FORWARD_NEXT = 'actionButtonForwardNext',
  /**
   * 上一个
   */
  ACTION_BUTTON_BACK_PREVIOUS = 'actionButtonBackPrevious',
  /**
   * 结束
   */
  ACTION_BUTTON_END = 'actionButtonEnd',
  /**
   * 开始
   */
  ACTION_BUTTON_BEGINNING = 'actionButtonBeginning',
  /**
   * 返回
   */
  ACTION_BUTTON_RETURN = 'actionButtonReturn',
  /**
   * 文档
   */
  ACTION_BUTTON_DOCUMENT = 'actionButtonDocument',
  /**
   * 声音
   */
  ACTION_BUTTON_SOUND = 'actionButtonSound',
  /**
   * 电影
   */
  ACTION_BUTTON_MOVIE = 'actionButtonMovie',
  ACTION_BUTTON_BLANK = 'actionButtonBlank',
  HOME_PLATE = 'homePlate',

  // 以下形状应该是其他版本 office 中的形状
  GEAR_6 = 'gear6',
  GEAR_9 = 'gear9',
  FUNNEL = 'funnel',
  CORNER_TABS = 'cornerTabs',
  SQUARE_TABS = 'squareTabs',
  PLAQUE_TABS = 'plaqueTabs',
  CHART_X = 'chartX',
  CHART_STAR = 'chartStar',
  CHART_PLUS = 'chartPlus',
  CHEVRON = 'chevron',
  PIE_WEDGE = 'pieWedge',
  LEFT_ARROW_CALLOUT = 'leftArrowCallout',
  RIGHT_ARROW_CALLOUT = 'rightArrowCallout',
  UP_ARROW_CALLOUT = 'upArrowCallout',
  DOWN_ARROW_CALLOUT = 'downArrowCallout',
  LEFT_RIGHT_ARROW_CALLOUT = 'leftRightArrowCallout',
  UP_DOWN_ARROW_CALLOUT = 'upDownArrowCallout',
  QUAD_ARROW_CALLOUT = 'quadArrowCallout',
  LINE_INV = 'lineInv',
  NON_ISOSCELES_TRAPEZOID = 'nonIsoscelesTrapezoid',
  SWOOSH_ARROW = 'swooshArrow',
  CIRCULAR_ARROW = 'circularArrow',
  LEFT_CIRCULAR_ARROW = 'leftCircularArrow',
  LEFT_RIGHT_CIRCULAR_ARROW = 'leftRightCircularArrow',
}

export const LineType = {
  /**
   * 线条
   */
  LINE: 'line',
  /**
   * 直线
   */
  STRAIGHT_CONNECTOR: 'straightConnector1',
  /**
   * 无控制点折线
   */
  BENT_CONNECTOR_0: 'bentConnector2',
  /**
   * 单控制点折线
   */
  BENT_CONNECTOR_1: 'bentConnector3',
  /**
   * 双控制点折线
   */
  BENT_CONNECTOR_2: 'bentConnector4',
  /**
   * 三控制点折线
   */
  BENT_CONNECTOR_3: 'bentConnector5',
  /**
   * 无控制点曲线
   */
  CURVED_CONNECTOR_0: 'curvedConnector2',
  /**
   * 单控制点曲线
   */
  CURVED_CONNECTOR_1: 'curvedConnector3',
  /**
   * 双控制点曲线
   */
  CURVED_CONNECTOR_2: 'curvedConnector4',
  /**
   * 三控制点曲线
   */
  CURVED_CONNECTOR_3: 'curvedConnector5',
};
